<template>
    <div class="inline-block">
        <a :href="targetLink" style="text-decoration: none" ref="link" @click="onClick">
            <img :src="target.avatar" width="40" height="40" class="img-circle vertical-middle" alt="Avatar">
            <strong class="vertical-middle">{{target.name}}</strong>
        </a><span class="vertical-middle" v-if="postfixLabel">{{postfixLabel}}</span>
    </div>
</template>

<script>
    import SimpleLinkMixin from "./SimpleLinkMixin";
    import RouterCheckAvailabilityMixin from "./RouterCheckAvailabilityMixin";

    export default {
        name: "SimpleLinkWithAvatar",
        // this rendered a bare <a href> while its plain-text twin routed, so the same link
        // reloaded the page or did not depending on whether it was drawn with an avatar
        mixins: [SimpleLinkMixin, RouterCheckAvailabilityMixin],
        computed: {
            availableInRouter() {
                return this.getRouterAvailability(this.target.link);
            },
        },
        methods: {
            onClick(e) {
                if (this.availableInRouter) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.$router.push(this.targetLink);
                }
            },
        },
    };
</script>
